import React, { useEffect, useState } from "react";
import { useDetailContext } from "../DetailContext";
import { ActionName, EventCallbackParamsType, MockupTextObject } from "../MockupEditor";
import CustomImage from "components/common/CustomImage";
import { SketchPicker } from "react-color";
import Config from "config/config";
import Stats from "libs/utils/stats";
import { useGuidesContext } from "../guide/Guides";

type TextProperty = {
    fontFamily: string,
    fontColor: string,
    fontSize: number,
    lineHeight: number,
    letterSpacing: number,
    textHorizontalAlign: number,
    textVerticalAlign: number
}

const DEFAULT_PROPETY : TextProperty = {
    fontFamily: '',
    fontColor: '#000000',
    fontSize: 20,
    lineHeight: 0,
    letterSpacing: 0,
    textHorizontalAlign: 0,
    textVerticalAlign: 0, 
}

// 文本组件
export default function TText(props: { isTextMode : boolean, onToolTypeUpdateCallback : (toolType: number) => void}){
    const { isTextMode, onToolTypeUpdateCallback } = props ;
    const detailContext = useDetailContext();
    const guidesContext = useGuidesContext();

    const [ textProperty, setTextProperty ]= useState<TextProperty>();
    const [ isSettingDefault, setIsSettingDefault ] = useState<boolean>(false);
    const [ isShowTextProperty, setIsShowTextProperty ] = useState<boolean>(false);

    const [ fontList, setFontList ] = useState<Font[]>();
    const [ isShowFontList, setIsShowFontList ] = useState<boolean>(false);
    const [ font, setFont] = useState<Font>();
    const [ fontDetail, setFontDetail ]= useState<FontDetail>();

    useEffect(() => {
        // 只需要设置一次默认的字体
        if(isTextMode){
            if(!isSettingDefault){
                setIsSettingDefault(true);
                const font = FONT_LIST[0];
                DEFAULT_PROPETY.fontFamily = font.children[font.defaultIndex || 0].url;
                setTimeout(() => {
                    detailContext?.triggerEditorAction({
                        name: ActionName.TEXT_DEFAULT_SETTING,
                        params:  DEFAULT_PROPETY as MockupTextObject
                    })
                }, 50)
            }
            if(!textProperty){
                const font = FONT_LIST[0];
                setFont(font);
                setFontDetail(font.children[font.defaultIndex || 0]);
                setTextProperty(() => {
                    return {...DEFAULT_PROPETY}
                });
                if(!guidesContext?.isGuideModal){
                    detailContext?.triggerEditorAction({
                        name: ActionName.SWITCH_EDITOR_MODE,
                        params: `2`
                    })
                }
            }
        }
        setIsShowTextProperty(isTextMode);
    }, [ isTextMode, guidesContext?.isGuideModal])

    useEffect(() => {
        if(!guidesContext?.isGuideModal) setTextProperty(undefined);
    }, [guidesContext?.isGuideModal])

    useEffect(() => {
        if(isShowFontList){
            document.body.addEventListener('click', hidePanel);
        }else{
            document.body.removeEventListener('click', hidePanel);
        }
    }, [ isShowFontList ])

    const hidePanel = () => {
        setIsShowFontList(false);
    }


    useEffect(() => {  
        disponseCallbackData();
    },[detailContext?.editorCallbackData])

    const controllerPanel = (event: React.MouseEvent) => {
        if(!isShowFontList){
            setFontList([...FONT_LIST]);
        }
        event.stopPropagation();
        setIsShowFontList(!isShowFontList)
    }

    // 处理相关的回调
    const disponseCallbackData = async () => {
        const data = detailContext?.editorCallbackData?.data as MockupTextObject ;
        const type = detailContext?.editorCallbackData?.type ;
        switch(type){
            // case EventCallbackParamsType.OBJECT_SELECT: // 对象选中
            //     if(data.type != 3){
            //         onToolTypeUpdateCallback(1);
            //     }
            //     break;
            case EventCallbackParamsType.TEXT_EDITING_CALLBACK: // 添加|对象大小修改
                // setIsShowTextProperty(true);
                const fontName = data.fontFamily.split('-') ;
                const currentFont = FONT_LIST?.find((f: Font) => f.fontName == fontName[0]) as Font;
                const currentFontDetail = currentFont.children.find((fd: FontDetail) => fd.fontName == fontName[1]) as FontDetail ;
                setFont(currentFont);
                setFontDetail(currentFontDetail);
                setTextProperty({
                    fontFamily: currentFontDetail.url,
                    fontColor: data.fontColor,
                    fontSize: Math.round(data.fontSize),
                    lineHeight: Math.round(data.lineHeight),
                    letterSpacing: Math.round(data.letterSpacing),
                    textHorizontalAlign: data.textHorizontalAlign,
                    textVerticalAlign: data.textVerticalAlign
                })
                onToolTypeUpdateCallback(2);
                break;
            case EventCallbackParamsType.TEXT_INPUT_FINISH: // 退出文字输入
                Stats.google('Text')
                break;
            case EventCallbackParamsType.TEXT_EXIT_CALLBACK: // 取消
            case EventCallbackParamsType.TEXT_TO_IMAGE_CALLBACK: // 文本转换成向量图后
                if(isShowTextProperty && textProperty){
                    setTextProperty(undefined)
                    onToolTypeUpdateCallback(1);
                }
                break;
        }
    }

    const changeTextProperty = (property: any) => {
        const tmpPro = {... textProperty, ...property};
        detailContext?.triggerEditorAction({
            name: ActionName.TEXT_SETTING,
            params: tmpPro as MockupTextObject
        })
        setTextProperty(tmpPro);
    }


    const changeFont = (index: number, event: React.MouseEvent) => {
        if(!fontList) return ;
        const _fontList = [...fontList];
        const font = _fontList[index];
        if(font.children.length > 1){
            event.stopPropagation();
            font.isExpall = !font.isExpall;
            return setFontList(_fontList)
        }
        changeFontDetail(font, font.children[0])
    }


    const changeFontDetail = (font: Font, fontDetail: FontDetail) => {
        setFont(font);
        setFontDetail(fontDetail);
        // changeTextProperty({ fontFamily: font.fontName + '-' + fontDetail.fontName})
        changeTextProperty({ fontFamily: fontDetail.url || (font.fontName + '-' + fontDetail.fontName)})
    }

    return (
        <>
            {
                isShowTextProperty && textProperty && 
                <div className="absolute z-[10001] h-full left-[100px] top-[0px] w-[320px] p-[20px] shadow-lg bg-[#FFFFFF]">
                    <div className="relative">
                        <div className="w-full py-[11px] pl-[15px] border rounded-[5px] cursor-pointer"
                            onClick={controllerPanel}>
                            <p><img src={font?.image} className="h-[20px]" /></p>
                            {
                                <CustomImage src="/icon/icon-layer-right.png" className={`absolute w-[20px] h-[20px] right-[10px] top-[12px] ${isShowFontList?'rotate-[90deg]':''}`} />
                            }
                        </div>
                        {
                            isShowFontList && 
                            <div className="absolute top-[47px] left-[0px] w-full bg-[#FFFFFF] rounded-[5px] z-[10] shadow-box max-h-[450px] overflow-y-auto flex flex-col">
                                {
                                    fontList?.map((item: Font, index: number) => (
                                        <div className="flex-1" key={item.fontName} >
                                            <p onClick={(event: React.MouseEvent) => changeFont(index, event)}
                                                className={`relative py-[11px] pl-[15px] hover:bg-[#D9F2FF] cursor-pointer ${index == 0 ? 'rounded-t-[5px]' : index == fontList.length - 1 && item.children.length == 0 ? 'rounded-b-[5px]' : ''}`}>
                                                    {/* {item.fontName} */}
                                                    <CustomImage src={item.image} className="h-[20px]" />
                                                {
                                                    item.children.length > 1 && 
                                                    <CustomImage src="/icon/icon-layer-right.png" className={`absolute w-[20px] h-[20px] right-[10px] top-[10px] ${item.isExpall?'rotate-[90deg]':''}`} />
                                                }
                                            </p>
                                            {
                                                item.isExpall && 
                                                <div className="">
                                                    {
                                                        item.children.map((sitem: FontDetail, sindex: number) => (
                                                            <p key={item.fontName + '-' + sitem.fontName} onClick={() => changeFontDetail(item,sitem)}
                                                                className={`py-[11px] pl-[35px] hover:bg-[#D9F2FF] cursor-pointer ${index == fontList.length - 1 && sindex == item.children.length - 1 ? 'rounded-b-[5px]' : ''}`}>
                                                                {/* {sitem.fontName} */}
                                                                <CustomImage src={sitem.image} className="h-[20px]" />
                                                            </p>
                                                        ))  
                                                    }
                                                </div> 
                                            }
                                        </div>
                                    ))
                                }
                            </div> 
                        }
                    </div>
                    <div className="flex gap-[10px] mt-[10px]">
                        <div className="flex-1 relative">
                            <StopInput type="number" min={1} value={textProperty?.fontSize} className="outline-none pl-[35px] text-[12px] border rounded-[5px] p-[10px] w-full "
                                onChange={(e: any) => {changeTextProperty({fontSize: (+e.target.value)})}}/>
                            <CustomImage src="/icon/icon-text-size.png" className="absolute left-[10px] top-[10px] w-[20px] h-[20px]" /> 
                        </div>
                        <div className="flex-1 relative">
                            <StopInput type="number" min={0} value={textProperty?.lineHeight} className="w-full outline-none pl-[35px] text-[12px] border rounded-[5px] p-[10px]"
                                onChange={(e: any) => {changeTextProperty({lineHeight: (+e.target.value)})}}/>
                            <CustomImage src="/icon/icon-text-line.png" className="absolute left-[10px] top-[10px] w-[20px] h-[20px]" />
                        </div>
                        <div className="flex-1 relative">
                            <StopInput type="number" min={0} value={textProperty?.letterSpacing} className="w-full outline-none pl-[35px] text-[12px] border rounded-[5px] p-[10px] "
                                onChange={(e: any) => {changeTextProperty({letterSpacing: (+e.target.value)})}}/>
                            <CustomImage src="/icon/icon-text-column.png" className="absolute left-[10px] top-[10px] w-[20px] h-[20px]" />                                
                        </div>
                    </div>
                    <div className="flex bg-[#EBEBEB] mt-[10px] py-[3px] rounded-[5px] px-[3px]">
                        <div className="flex-1 flex items-center justify-center py-[7px]  rounded-[5px] cursor-pointer" 
                            style={{
                                ...( textProperty.textHorizontalAlign == 1 ? { background: '#ffffff'} : {})
                            }}
                            onClick={() => changeTextProperty({textHorizontalAlign: 1})}>
                            <CustomImage src={`/icon/icon-text-halign-0${textProperty.textHorizontalAlign == 1 ? '-active':''}.png`} className="w-[20px] h-[20px]" />
                        </div>
                        <div className="flex-1 flex items-center justify-center py-[7px]  rounded-[5px] cursor-pointer" 
                            style={{
                                ...( textProperty.textHorizontalAlign == 0 ? { background: '#ffffff'} : {})
                            }}
                            onClick={() => changeTextProperty({textHorizontalAlign: 0})}>
                            <CustomImage src={`/icon/icon-text-halign-1${textProperty.textHorizontalAlign == 0 ? '-active':''}.png`} className="w-[20px] h-[20px]" />
                        </div>
                        <div className="flex-1 flex items-center justify-center py-[7px]  rounded-[5px] cursor-pointer" 
                            style={{
                                ...( textProperty.textHorizontalAlign == 2 ? { background: '#ffffff'} : {})
                            }}
                            onClick={() => changeTextProperty({textHorizontalAlign: 2})}>
                            <CustomImage src={`/icon/icon-text-halign-2${textProperty.textHorizontalAlign == 2 ? '-active':''}.png`} className="w-[20px] h-[20px]" />
                        </div>
                    </div>
                    <div className="mt-[10px] w-full relative">
                        <SketchPicker color={textProperty.fontColor} disableAlpha={true} className="rounded-[5px] !shadow-none border xl:!w-[95%] !w-[90%]" 
                            onChange={(color) => changeTextProperty({ fontColor: color.hex})} />
                    </div>
                </div>
            }
        </>
    )
}

const StopInput = (props: any) => {
    return (
        <input {...props} 
            onKeyDown={(e) => e.stopPropagation()}
            onKeyUp={(e) => e.stopPropagation()}/>
    )
}

type FontDetail = {
    fontName : string,
    image ?: string,
    url : string
}
type Font = {
    fontName: string,
    defaultIndex ?: number,
    image : string,
    isExpall ?: boolean,
    children : FontDetail[]
}

const fontsUrl = Config.fontsUrl ;
const FONT_LIST : Font[] = [{
    fontName: 'Inter',
    image : fontsUrl + '/Inter/Inter.png',
    defaultIndex: 3,
    children : [
        { fontName: 'Thin', url: fontsUrl + '/Inter/Inter-Thin.ttf', image: fontsUrl + '/Inter/Inter-Thin.png'},
        { fontName: 'ExtraLight', url:fontsUrl + '/Inter/Inter-ExtraLight.ttf', image: fontsUrl + '/Inter/Inter-ExtraLight.png'},
        { fontName: 'Light', url:fontsUrl + '/Inter/Inter-Light.ttf', image: fontsUrl + '/Inter/Inter-Light.png'},
        { fontName: 'Regular', url:fontsUrl + '/Inter/Inter-Regular.ttf', image: fontsUrl + '/Inter/Inter-Regular.png'},
        { fontName: 'Medium', url:fontsUrl + '/Inter/Inter-Medium.ttf', image: fontsUrl + '/Inter/Inter-Medium.png'},
        { fontName: 'SemiBold', url:fontsUrl + '/Inter/Inter-SemiBold.ttf', image: fontsUrl + '/Inter/Inter-SemiBold.png'},
        { fontName: 'Bold', url:fontsUrl + '/Inter/Inter-Bold.ttf', image: fontsUrl + '/Inter/Inter-Bold.png'},
        { fontName: 'ExtraBold', url:fontsUrl + '/Inter/Inter-ExtraBold.ttf', image: fontsUrl + '/Inter/Inter-ExtraBold.png'},
        { fontName: 'Black', url:fontsUrl + '/Inter/Inter-Black.ttf', image: fontsUrl + '/Inter/Inter-Black.png'},
    ]
},{
    fontName: 'Boisu',
    image: fontsUrl + '/Boisu/Boisu.png',
    children : [
        { fontName: 'Regular', url: fontsUrl + '/Boisu/Boisu-Regular.otf'},
    ]
},{
    fontName: 'Caroni',
    image : fontsUrl + '/Caroni/Caroni.png',
    children : [
        { fontName: 'Regular', url: fontsUrl + '/Caroni/Caroni-Regular.otf'},
    ]
},{
    fontName: 'Cramaten',
    image : fontsUrl + '/Cramaten/Cramaten.png',
    children : [
        { fontName: 'Regular', url: fontsUrl + '/Cramaten/Cramaten-Regular.ttf'},
    ]
},{
    fontName: 'DisclaimerPlain',
    image: fontsUrl + '/DisclaimerPlain/DisclaimerPlain.png',
    children : [
        { fontName: 'Regular', url: fontsUrl + '/DisclaimerPlain/DisclaimerPlain-Regular.otf'},
    ]
},{
    fontName: 'Engry',
    image: fontsUrl + '/Engry/Engry.png',
    children : [
        { fontName: 'Regular', url: fontsUrl + '/Engry/Engry-Regular.otf'},
    ]
},{
    fontName: 'Ghibli',
    image: fontsUrl + '/Ghibli/Ghibli.png',
    children : [
        { fontName: 'Regular', url: fontsUrl + '/Ghibli/Ghibli-Regular.otf', image: fontsUrl + '/Ghibli/Ghibli-Regular.png'},
        { fontName: 'Bold', url: fontsUrl + '/Ghibli/Ghibli-Bold.otf', image: fontsUrl + '/Ghibli/Ghibli-Bold.png'},
    ]
},{
    fontName: 'GreatVibes',
    image: fontsUrl + '/GreatVibes/GreatVibes.png',
    children : [
        { fontName: 'Regular', url: fontsUrl + '/GreatVibes/GreatVibes-Regular.otf'},
    ]
},{
    fontName: 'IvoryHeart',
    image: fontsUrl + '/IvoryHeart/IvoryHeart.png',
    children : [
        { fontName: 'Regular', url: fontsUrl + '/IvoryHeart/IvoryHeart-Regular.ttf'},
    ]
},{
    fontName: 'KaushanScript',
    image: fontsUrl + '/KaushanScript/KaushanScript.png',
    children : [
        { fontName: 'Regular', url: fontsUrl + '/KaushanScript/KaushanScript-Regular.otf'},
    ]
},{
    fontName: 'Kerao',
    image: fontsUrl + '/Kerao/Kerao.png',
    children : [
        { fontName: 'Regular', url: fontsUrl + '/Kerao/Kerao-Regular.ttf'},
    ]
},{
    fontName: 'Krisha',
    image: fontsUrl + '/Krisha/Krisha.png',
    children : [
        { fontName: 'Regular', url: fontsUrl + '/Krisha/Krisha-Regular.otf'},
    ]
},{
    fontName: 'MilkyCoffee',
    image: fontsUrl + '/MilkyCoffee/MilkyCoffee.png',
    children : [
        { fontName: 'Regular', url: fontsUrl + '/MilkyCoffee/MilkyCoffee-Regular.ttf'},
    ]
},{
    fontName: 'Modernia',
    image: fontsUrl + '/Modernia/Modernia.png',
    children : [
        { fontName: 'Regular', url: fontsUrl + '/Modernia/Modernia-Regular.otf'},
    ]
},{
    fontName: 'Nickainley',
    image: fontsUrl + '/Nickainley/Nickainley.png',
    children : [
        { fontName: 'Regular', url: fontsUrl + '/Nickainley/Nickainley-Regular.otf'},
    ]
},{
    fontName: 'PragatiNarrow',
    image: fontsUrl + '/PragatiNarrow/PragatiNarrow.png',
    children : [
        { fontName: 'Regular', url: fontsUrl + '/PragatiNarrow/PragatiNarrow-Regular.otf', image: fontsUrl + '/PragatiNarrow/PragatiNarrow-Regular.png'},
        { fontName: 'Bold', url: fontsUrl + '/PragatiNarrow/PragatiNarrow-Bold.otf', image: fontsUrl + '/PragatiNarrow/PragatiNarrow-Bold.png'},
    ]
},{
    fontName: 'Raleway',
    image: fontsUrl + '/Raleway/Raleway.png',
    children : [
        { fontName: 'Regular', url: fontsUrl + '/Raleway/Raleway-Regular.ttf',},
    ]
},{
    fontName: 'SendaDisplay',
    image: fontsUrl + '/SendaDisplay/SendaDisplay.png',
    children : [
        { fontName: 'Regular', url: fontsUrl + '/SendaDisplay/SendaDisplay-Regular.otf'},
    ]
},{
    fontName: 'TarponMotel',
    image: fontsUrl + '/TarponMotel/TarponMotel.png',
    children : [
        { fontName: 'Regular', url: fontsUrl + '/TarponMotel/TarponMotel-Regular.otf'},
    ]
},{
    fontName: 'UmbaSlab',
    image: fontsUrl + '/UmbaSlab/UmbaSlab.png',
    children : [
        { fontName: 'Regular', url: fontsUrl + '/UmbaSlab/UmbaSlab-Regular.otf', image: fontsUrl + '/UmbaSlab/UmbaSlab-Regular.png'},
        { fontName: 'Italic', url: fontsUrl + '/UmbaSlab/UmbaSlab-Italic.otf', image: fontsUrl + '/UmbaSlab/UmbaSlab-Italic.png'},
    ]
},{
    fontName: 'YunmobeiEnfont',
    image: fontsUrl + '/YunmobeiEnfont/YunmobeiEnfont.png',
    children : [
        { fontName: 'Regular', url: fontsUrl + '/YunmobeiEnfont/YunmobeiEnfont-Regular.ttf'},
    ]
}]
